import React, { Component } from 'react';

interface StudentStudyBannerProps {
  isVisible: boolean;
  className?: string;
  children: React.ReactNode;
}

// TODO: Delete this banner and swap for Leyden Banner component after upgrade past Node v14
class StudentStudyBanner extends Component<StudentStudyBannerProps> {

  render() {
    const {
      isVisible,
      className,
      children
    } = this.props;
    if (!isVisible) {
      return null;
    }

    return (
      <div className={`c-ssa-student-study-banner ${className || ''}`} data-testid="ssa-student-study-banner">
        {children}
      </div>
    );
  }
}

export default StudentStudyBanner;
